var defaultDate = true;
window.addEventListener('DOMContentLoaded', (event)=>{
   
    //google.charts.setOnLoadCallback(drawChart);

    event.preventDefault();

    /*** INTIAL AJAX CALL TO GET DASHBOARD COUNT */

    /*google.charts.load('current', {'packages':['bar']}).then(getChartData);*/
    google.charts.load('current', { packages:['corechart'] }).then(getChartData);

    function getChartData(p){
        var formData = {'date_range':$("#daterange").val(),'defaultDate':defaultDate};
        window.axios({
            method: "post",
            url: window.$("#infographics").attr('link'),
            data: formData,
            headers: { "Content-Type": "application/json" },
        })
        .then(function(response) {
           defaultDate = false;
           if(response.data.infographdata){
               drawChart(response.data.infographdata);
           }
        })
        .catch(function(error) {
           
        });
        //drawChart(chartData);
    }
    function drawChart(response) { 
        //console.log(response.chartData);
        var array = [];
        var seriesarr = [];
        array.push(response.labels);

        if (response.totalGoogleRec == 0) {
            $.each(response.chartData, function(key, row){
                if (row.Walkin === 0)
                    row.Walkin = -1;
                if (row.Offline === 0)
                    row.Offline = -1;
                if (row.Widget === 0)
                    row.Widget = -1;
                
                array.push([
                    key,
                    row.Widget,
                    row.tooltipWidget,
                    row.Offline,
                    row.tooltipOffline,
                    row.Walkin,
                    row.tooltipWalkin
                ]);
                
            //array.push([key,row.Reservation,row.Cancelled,row.Checked_out]);
            });
        } else {
            $.each(response.chartData, function(key, row){
                if (row.Google === 0)
                    row.Google = -1;
                if (row.Walkin === 0)
                    row.Walkin = -1;
                if (row.Offline === 0)
                    row.Offline = -1;
                if (row.Widget === 0)
                    row.Widget = -1;
                
                array.push([
                    key,
                    row.Widget,
                    row.tooltipWidget,
                    row.Offline,
                    row.tooltipOffline,
                    row.Walkin,
                    row.tooltipWalkin,
                    row.Google,
                    row.tooltipGoogle
                ]);
                
            //array.push([key,row.Reservation,row.Cancelled,row.Checked_out]);
            });
        }
        $.each(response.color,function(key,row){
            seriesarr.push({color:row});
        });
        let ob = {...seriesarr};
        //console.log(array);
        var datatable = google.visualization.arrayToDataTable(array);
        /*console.log(datatable);
        // build view
        var view = new google.visualization.DataView(datatable);
        var viewColumns = [];
        $.each(new Array(datatable.getNumberOfColumns()), function (col) {
            console.log(col);
            viewColumns.push({
                calc: function (dt, row) {
                    var value = dt.getValue(row, col);
                    if (value === 0) {
                        value = -1 ;
                    }
                    return value;
                },
                label: datatable.getColumnLabel(col),
                type: datatable.getColumnType(col),
                role: datatable.getColumnRole(col),
                p: { html: true }
            });
        });
        console.log(viewColumns);
        view.setColumns(viewColumns);*/

        var totalRecods = Object.keys(response.chartData).length;
        //console.log(totalRecods);
        var options = {
            tooltip: { isHtml: true },
            isStacked:true,
            theme: 'material',
            hAxis: {
                title: 'Weeks',
                textStyle : {
                    fontSize: '14'
                },
                viewWindow:{
                    min:0
                }
            },
            vAxis: {
                format:'#',
                title: 'No. of Reservations',
                textStyle : {
                    fontSize: '14'
                },
                viewWindow:{
                    min:0,
                    max:(response.totalRec == 0) ? 10 : ''
                },
            },
            width:(totalRecods == 1)? 650 : 1200,
            height:550,
            series: ob,
            legend: {
                textStyle : {
                    fontSize: '14'
                }
            }
        };
       
        /*var chart = new google.charts.Bar(document.getElementById('infographics'));
        chart.draw(datatable, google.charts.Bar.convertOptions(options));*/
        var chart = new google.visualization.ColumnChart(document.getElementById('infographics'));
        chart.draw(datatable, options);        

        // a click handler 
        google.visualization.events.addListener(chart, 'select', function() {
            // grab a few details
            var selection = chart.getSelection(); 
            if(selection.length === 0)
                return;
            var row = selection[0].row;
            var data = response.chartData[datatable.getValue(row, 0)];
            //var col = selection[0].column;

            /*google.charts.load('current', {'packages':['bar']}).then(getDayChartData);*/
            //google.charts.load('current', { packages:['corechart'] }).then(getDayChartData);

            google.charts.load('current', { packages:['corechart'] }).then(                
                function () {
                    $('#infographicsdayTitle').html('');
                    $('#infographicsday').html('');
                    window.$("#dayWiseGraphicModal").modal("show");
                    
                    $("#dayWiseGraphicModal").on('shown.bs.modal', function () {
                        getDayChartData();
                    });
                }
            );

            function getDayChartData(p){
                var formDayData = {'year':data.year,'week':data.week};
                window.axios({
                    method: "post",
                    url: window.$("#infographicsday").attr('link'),
                    data: formDayData,
                    headers: { "Content-Type": "application/json" },
                })
                .then(function(response) { 
                    //console.log(response.data.infographdata);
                    data = false;
                    if(response.data.infographdata){
                        drawDayChart(response.data.infographdata);
                    }
                })
                .catch(function(error) {
                    //
                });
                //drawChart(chartData);
            }

            function drawDayChart(response) {
                var array = [];
                var seriesarr = [];
                array.push(response.labels);

                if (response.totalGoogleDRec == 0) {
                    $.each(response.chartData, function(key, row){
                        if (row.WalkinD === 0)
                            row.WalkinD = -1;
                        if (row.OfflineD === 0)
                            row.OfflineD = -1;
                        if (row.WidgetD === 0)
                            row.WidgetD = -1;

                        array.push([
                            key,
                            row.WidgetD,
                            row.tooltipWidgetD,
                            row.OfflineD,
                            row.tooltipOfflineD,
                            row.WalkinD,
                            row.tooltipWalkinD
                        ]);
                    });
                } else {
                    $.each(response.chartData, function(key, row){
                        if (row.GoogleD === 0)
                            row.GoogleD = -1;
                        if (row.WalkinD === 0)
                            row.WalkinD = -1;
                        if (row.OfflineD === 0)
                            row.OfflineD = -1;
                        if (row.WidgetD === 0)
                            row.WidgetD = -1;

                        array.push([
                            key,
                            row.WidgetD,
                            row.tooltipWidgetD,
                            row.OfflineD,
                            row.tooltipOfflineD,
                            row.WalkinD,
                            row.tooltipWalkinD,
                            row.GoogleD,
                            row.tooltipGoogleD
                        ]);
                    });
                }
                $.each(response.color,function(key,row){
                    seriesarr.push({color:row});
                });
                let ob = {...seriesarr};
                var datatable = google.visualization.arrayToDataTable(array);
                var totalRecods = Object.keys(response.chartData).length;
                var chartTitle = response.selectedWeek;
                
                var options = {
                    tooltip: { isHtml: true },
                    isStacked:true,
                    theme: 'material',
                    hAxis: {
                        title: 'Days',
                        textStyle : {
                            fontSize: '14'
                        }
                    },
                    vAxis: {
                        format: '#',
                        title: 'No. of Reservations',
                        textStyle : {
                            fontSize: '14'
                        },
                        viewWindow:{ 
                            min: 0,
                            max:(response.totalRec == 0) ? 10 : ''
                         }
                    },
                    width:(totalRecods == 1)? 650 : 1200,
                    height:550,
                    series: ob,
                    legend: {
                        textStyle : {
                            fontSize: '14'
                        }
                    }
                };
        
                /*var dayChart = new google.charts.Bar(document.getElementById('infographicsday'));
                dayChart.draw(datatable, google.charts.Bar.convertOptions(options));*/

                var dayChart = new google.visualization.ColumnChart(document.getElementById('infographicsday'));
                dayChart.draw(datatable, options);

                google.visualization.events.addListener(dayChart, 'ready', function () {
                    $('#infographicsdayTitle').text('Week ' + chartTitle);
                });
            }

            //window.$("#dayWiseGraphicModal").modal("show");
        });
    }
    
    var getCountData = function(){
        setTimeout(function(){
            var formData = {'date_range':$("#daterange").val()};
            window.axios({
                method: "post",
                url: window.$("#dashboard-content").attr('link'),
                data: formData,
                headers: { "Content-Type": "application/json" },
            })
            .then(function(response) {
               if(response.data.data){
                   var upcomingCount = response.data.data['upcomingReservation'];
                   var cancelCount = response.data.data['cancelReservation'];
                   var amountOfGuest = response.data.data['amountOfGuest'];
                   var seatedCount = response.data.data['seated'];
                   var noshowCount = response.data.data['noshow'];
                   var totalreservation = response.data.data['totalReservation'];
                   var totalCovered = response.data.data['totalCovered'];
                   var totalCoveredLunch = response.data.data['totalCoveredLunch'];
                   var totalCoveredDinner = response.data.data['totalCoveredDinner'];
                   var seatedCovered = response.data.data['seatedCovered'];
                   var totalBreakfastReservation = response.data.data['totalBreakfastReservation'];
                   var totalLunchReservation = response.data.data['totalLunchReservation'];
                   var totalDinnerReservation = response.data.data['totalDinnerReservation'];
                   
                   $("#reservationCount").html(upcomingCount);
                   $("#cancelledCount").html(cancelCount);
                   $("#amountOfGuest").html(amountOfGuest);
                   $("#seatedCount").html(seatedCount);
                   $("#noshowCount").html(noshowCount);
                   $("#totalReservation").html(totalreservation);
                   $("#totalCovers").html(totalCovered);
                   $("#totalCoversLunch").html(totalCoveredLunch);
                   $("#totalCoversDinner").html(totalCoveredDinner);
                   $("#seatedCovers").html(seatedCovered);
                   $("#totalBreakfastReservation").html(totalBreakfastReservation);
                   $("#totalLunchReservation").html(totalLunchReservation);
                   $("#totalDinnerReservation").html(totalDinnerReservation);                   
               }
            })
            .catch(function(error) {
               
            });
        });
    }
    var getNotes = function(){
        setTimeout(function(){
            var formData = {'date_range':$("#daterange").val()};
            window.axios({
                method: "post",
                url: window.$("#dailynote-table").attr('link'),
                data: formData,
                headers: { "Content-Type": "application/json" },
            })
            .then(function(response) {
               if(response.data.data.length > 0){
                   var tbody = '';
                   for(var prop in response.data.data){
                       var current = response.data.data[prop];
                        tbody +='<tr><td style="width:70%" title="'+current['fullNotes']+'">'+current['wrapNote']+'</td><td>'+current['date']+'</td>';

                   }
                   $("#note_table_body").css('text-align','none');
                   $("#note_table_body").html(tbody);
               }else{
                //$("#note_table_body").css('text-align','center');
                $("#note_table_body").html('<tr><td colspan="2">No record found</td></tr>');
               }
            })
            .catch(function(error) {
               
            });
        });
    }
    var getResNotes = function(){
        setTimeout(function(){
            var formData = {'date_range':$("#daterange").val()};
            window.axios({
                method: "post",
                url: window.$("#spec-res-note-table").attr('link'),
                data: formData,
                headers: { "Content-Type": "application/json" },
            })
            .then(function(response) {
               if(response.data.data.length>0){
                   var tbody = '';
                   for(var prop in response.data.data){
                       var current = response.data.data[prop];
                        tbody +='<tr><td>'+current['name']+'</td><td>'+current['date']+'</td><td>'+current['slot']+'</td><td>'+current['no_of_guest']+'</td><td>'+current['table_name']+'</td><td>'+current['area_name']+'</td><td>'+current['spl_req']+'</td><td>'+current['notes']+'</td>';

                   }
                   $("#res_notes").css('text-align','none');
                   $("#res_notes").html(tbody);
               }else{
                $("#res_notes").css('text-align','center');
                $("#res_notes").html('<tr><td colspan="7">No record found</td></tr>');
               }
            })
            .catch(function(error) {
               
            });
        });
    }
    var getSlotsData = function(){
        setTimeout(function(){
            var formData = {'date_range':$("#daterange").val()};
            window.axios({
                method: "post",
                url: window.$("#slot-table").attr('link'),
                data: formData,
                headers: { "Content-Type": "application/json" },
            })
            .then(function(response) {
                var header = ['Maximum cover','Covers','Percentage'];
               if(response.data){
                   var resData = response.data;
                   var tableDom;
                   var tableHead;
                   var objKeys = _.keys(resData);
                   //console.log(objKeys.length);
                   if(objKeys.length >= 1 && objKeys.length <= 10){
                       $("#slot-table").css('display','');
                   }else{
                    $("#slot-table").css('display','block');
                   }
                   var innertd='';
                   var covertd, reservationtd,percentagetd;
                   tableHead += '<tr style="text-align:center;">'
                   tableHead += '<th>DATE</th>'
                   for(var prop in resData){
                    tableHead += '<th scope="col">'+prop+'</th>';
                   }
                   tableHead += '</tr>';
                   $("#slot-table thead").html(tableHead);
                   for(var i=0; i < header.length; i++){
                    if (i==0)
                        var rowTitle = header[i].replace(/ /g,"_");
                    else
                        var rowTitle = header[i];

                    tableDom += '<tr id="'+rowTitle+'" style="text-align:center;">';
                    tableDom += '<th scope="row">'+header[i]+'</th>';
                    tableDom += '</tr>';
                   }
                   $("#slot-table tbody").html(tableDom);
                   for(var j=0; j < objKeys.length;j++){
                    covertd = '<td>'+resData[objKeys[j]].total_cover+'</td>';
                    reservationtd = '<td>'+resData[objKeys[j]].total_reservation+'</td>';
                    percentagetd = '<td>'+resData[objKeys[j]].percentage+'%</td>';

                    $("#Maximum_cover").append(covertd);
                    $("#Covers").append(reservationtd);
                    $("#Percentage").append(percentagetd);
                   }
                    //tableDom += innertd;
                   
               }else{
                $("#res_notes").css('text-align','center');
                $("#res_notes").html('<tr><td colspan="7">No record found</td></tr>');
               }
            })
            .catch(function(error) {
               
            });
        });
    }

    getCountData();
    getNotes();
    getResNotes();
    getSlotsData();
    // $('#dailynote-table').paginate({ limit: 10 });
    // $("#spec-res-note-table").paginate({limit:10});
    /*** NOTES DATATABLE */
 
      /*** special and reservation notes datatable */

    /*** NOTES DATATABLE END */
    /*** NOTES BUTTON CLICK EVENTS START*/
     $("#dailynotes").on('click',function(e){
         e.preventDefault();
         $("#sp-re-notes").removeClass('selected').addClass('not-selected');
         $(this).removeClass('not-selected').addClass('selected')
         $(".special-reser-notes").css('display','none');
         $(".daily-notes").css('display','block');
     });
     $("#sp-re-notes").on('click',function(e){
        e.preventDefault();
        $("#dailynotes").removeClass('selected').addClass('not-selected');
        $(this).removeClass('not-selected').addClass('selected');
        $(".special-reser-notes").css('display','block');
         $(".daily-notes").css('display','none');
    });
    /*** NOTES BUTTON CLICK EVENTS END */

    /*** DATERANE PICKER */
    $('#daterange').on('apply.outsideClick', function(ev, picker) {
        getCountData();
        getNotes();
        getResNotes();
        getSlotsData();
        getChartData();
    });
    $('.next-day').on('click', function () {
        var date = $('#daterangePicker').datepicker('getDate');
        todayDateObj.setDate(todayDateObj.getDate()+1);
        getNextPreDate(todayDateObj);
        getCountData();
        getNotes();
        getResNotes();
        getSlotsData();
        getChartData();
    });
   $(document).on('click', '.applyBtn', function () {
       $('apply.daterangepicker').click();
    });
    $('.prev-day').on('click', function () {
        var date = $('#daterangePicker').datepicker('getDate');
        todayDateObj.setDate(todayDateObj.getDate()-1);
        getNextPreDate(todayDateObj);
        getCountData();
        getNotes();
        getResNotes();
        getSlotsData();
        getChartData();
    });
      
    $('#daterange').on('apply.daterangepicker', function(ev, picker) {
        var startDate = picker.startDate;
        var endDate = picker.endDate;
        getCountData();
        getNotes();
        getResNotes();
        getSlotsData();
        getChartData('dateSelect');
      });
    
    getNextPreDate(new Date());
     
    function add_weeks(dt, n) 
    {
    return new Date(dt.setDate(dt.getDate() + (n * 7)));      
    }
    function minus_weeks(dt, n) 
    {
    return new Date(dt.setDate(dt.getDate() - (n * 7)));      
    }
    $('#daterangeinfo').on('apply.daterangepicker', function(ev, picker) {
        var startDate = picker.startDate;
        var endDate = picker.endDate;
        getChartData();

      });
      let def_start_date = minus_weeks(new Date(), 4);
      let def_end_date = add_weeks(new Date(), 8);

      var dateMethod1 = $('input[name="daterangeinfo"]').daterangepicker({
        startDate: def_start_date,
        endDate: def_end_date,
        opens: 'left',
        locale: {
            format: DATE_FORMAT_GUEST,
            firstDay:1
        },
        outsideClick: function(t) {
            
        }
      }, function(start, end, label) {
        
    });
    /*** DATERANGE PICKER END */

    /*** SHOW DATE IN HEADER SECTION START*/
     let todayDateObj = new Date();
     displayDate(todayDateObj);

        /** PREVIOUS DATE CLICK */
        $("#previous_date").on('click',function(e){
            e.preventDefault();
            todayDateObj.setDate(todayDateObj.getDate()-1);
            displayDate(todayDateObj);
        });

        /** NEXT DATE CLICK */
        $("#next_date").on('click',function(e){
            e.preventDefault();
            todayDateObj.setDate(todayDateObj.getDate()+1);
            displayDate(todayDateObj);
        });

    /*** SHOW DATE IN HEADER SECTION END*/

});

/** UTILS FUNCTION */
var displayDate = function(objDate){
    let monthName = getMonthName(objDate);
     let dayName = getDayName(objDate);
     let todayDate = dayName+", "+objDate.getDate()+" "+monthName;
     $("#date_header").text(todayDate);
}
var getDayName = function(objDate){
    var locale = LOCALE,
        dayName = objDate.toLocaleString(locale, { weekday: "long" });
  
      return dayName;
}
var getMonthName = function(objDate) {
    objDate.setMonth(objDate.getMonth());
    var locale = LOCALE,
        month = objDate.toLocaleString(locale, { month: "long" });
      return month;
}

var getNextPreDate = function(todayDateObj){
    var dateMethod = $('input[name="daterange"]').daterangepicker({
        startDate: todayDateObj,
        endDate: todayDateObj,
        opens: 'left',
        locale: {
            format: DATE_FORMAT_GUEST,
            firstDay:1
        },
        outsideClick: function(t) {
            
        }
      }, function(start, end, label) {
        
    });
}
